<template>  
    <div class="r-faq-item" :class="show ? 'r-show-faq' : 'r-hide-faq'">
        <div class="r-faq-question r-center-flex" @click.prevent="show = !show">
            <p>{{data.question}}</p>
            <div class="r-isFlex r-faq-icon">
                <img :src="require(`@/assets/icons/other/sortBy-arrow-blue.svg`)"> 
            </div>
        </div>
        <div class="r-faq-answer" v-html="data.answer">
        </div>
    </div>
</template>
<script>
export default {
    props: {
        show: {
            default: false
        },
        data: {
            require: true
        }
    }
}
</script>